import { AddAlertOutlined } from '@mui/icons-material';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { interactionTypeRootPathName } from '@/helpers';
import { NeedsAttentionCard } from '@/views/Home/components/NeedsAttention/components/NeedsAttentionCard';
import {
  TrackHomePageEvent,
  useTrackHomePageAnalytics,
} from '$analytics/useTrackAnalytics/domains/homePage';
import { EnvelopeRemindersInteractionSelectionModal } from './EnvelopeRemindersInteractionSelectionModal';

interface Props {
  envelopeCount: number;
  interactionCount: number;
  interactions: {
    id: string;
    type: string;
  }[];
}
export function EnvelopesNeedReminders({
  envelopeCount,
  interactionCount,
  interactions,
}: Props) {
  const [modalOpen, setModalOpen] = useState(false);

  const trackEvent = useTrackHomePageAnalytics();
  const router = useRouter();

  const supplementaryDetails: string[] = ['Sent more than 1 day ago'];

  if (interactionCount > 1) {
    supplementaryDetails.push(`Across ${interactionCount} transactions`);
  }

  const handleClick = () => {
    trackEvent(TrackHomePageEvent.NeedsAttentionCardClick, {
      numItem: interactionCount,
      eventTarget: 'envelope',
    });

    if (interactionCount > 1) {
      setModalOpen(true);
    } else {
      const { id = '', type = '' } = interactions?.at(0) ?? {};
      const rootPath = interactionTypeRootPathName(type);

      void router.push(
        `/${rootPath}/${id}/documents?utm_source=hp&utm_medium=nac`,
      );
    }
  };

  useEffect(() => {
    if (!interactionCount) return;

    trackEvent(TrackHomePageEvent.NeedsAttentionCardMount, {
      numItem: interactionCount,
      eventTarget: 'envelope',
    });
  });

  return (
    <>
      <EnvelopeRemindersInteractionSelectionModal
        numItems={interactionCount}
        onClose={() => setModalOpen(false)}
        open={modalOpen}
      />
      <NeedsAttentionCard
        itemCount={envelopeCount}
        color="warning"
        headerStartAdornment={<AddAlertOutlined />}
        onClick={handleClick}
        supplementaryDetails={supplementaryDetails}
        title="Envelopes Need Reminders"
      />
    </>
  );
}

EnvelopesNeedReminders.displayName = 'EnvelopesNeedReminders';
